export const Logo = ({ size = 40, showText = false }) => (
  <div className="flex items-center gap-3">
    <div className="hi-plaque rounded-lg overflow-hidden flex items-center justify-center" style={{ width: size, height: size, padding: 2 }}>
      <img src="/logo.jpg" alt="Hair Identity" className="w-full h-full object-contain" />
    </div>
    {showText && (
      <div className="leading-tight">
        <div className="font-brand text-xl font-semibold tracking-wide">Identity OS</div>
        <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">Hair Identity</div>
      </div>
    )}
  </div>
);
